export default __webpack_public_path__ + "/assets/home-events-02.png";